import Swiper from 'swiper/bundle';
import 'blockui';
import 'select2';
import Masonry from 'masonry-layout';

export default {
  init() {},
  finalize() {
    /**
     * Grid Task
     * @Masonry
     */
    if ($('.taskMasonry').length) {
      $('.taskMasonry').each(function (index) {
        var $elem = 'masonry-task-' + index;

        $(this).addClass($elem);

        var $masonry = '.' + $elem;

        var $grid = {};

        $grid[index] = new Masonry($masonry, {
          percentPosition: true,
          itemSelector: '.taskMasonry-item',
          gutter: 0,
          transitionDuration: 0,
          columnWidth: '.grid-sizer',
        });

        $(window).on('load resize', function () {
          $grid[index].reloadItems();
          $grid[index].layout();
        });
      });
    }

    /**
     * News & Events
     * @Masonry
     */
    if ($('.newseventsMasonry').length) {
      $('.newseventsMasonry').each(function (index) {
        var $elem = 'masonry-newsevents-' + index;

        $(this).addClass($elem);

        var $masonry = '.' + $elem;

        var $grid = {};

        $grid[index] = new Masonry($masonry, {
          percentPosition: true,
          itemSelector: '.newseventsMasonry-item',
          gutter: 0,
          transitionDuration: 0,
          columnWidth: '.grid-sizer',
        });

        $(window).on('load resize', function () {
          $grid[index].reloadItems();
          $grid[index].layout();
        });
      });
    }

    /**
     * GlobalElements
     * @type {{init: init}}
     */
    let GlobalElements = (function () {
      /**
       * Accordion
       * @param data
       * @constructor
       */
      let Accordion = function () {
        /**
         * Accordion
         * @click
         */
        $(document).on('click', '.accordion-title', function (e) {
          const $li = $(this).parent();

          if ($li.hasClass('active')) {
            $('.accordion').find('.active').removeClass('active');
          } else {
            $('.accordion').find('.active').removeClass('active');
            $li.addClass('active');
          }

          e.preventDefault();
        });
      };

      /**
       * Downloads
       * @constructor
       */
      let Downloads = function () {};

      /**
       * FloatingBanner
       * @constructor
       */
      let FloatingBanner = function () {
        $(window)
          .on('scroll', function () {
            let windowPosition = $(window).scrollTop(),
              topPanel = 115,
              window_width = $(window).width();

            if (window_width < 1200) {
              topPanel = 0;
            }

            if (windowPosition > topPanel && windowPosition < 810) {
              $('.floating_section').addClass('scroll');
            } else {
              $('.floating_section').removeClass('scroll');
            }
          })
          .scroll();
      };

      /**
       * Sticky
       * @constructor
       */
      let Sticky = function () {
        $(document).on(
          'click',
          '.dynamic__navsections ul > li > a',
          function (e) {
            const elem = $(this).attr('href'),
              top = $(elem).offset().top;

            $('body,html').animate({ scrollTop: top }, 400);

            $('.dynamic__navsections ul')
              .find('li.active')
              .removeClass('active');
            $(this).parent().addClass('active');

            e.preventDefault();
          }
        );
      };

      let DynamicSlider = function () {
        if ($('.dynamic__slider').length > 0) {
          new Swiper('.dynamic__slider .swiper-container', {
            autoHeight: true, //enable auto height
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            effect: 'fade',
            speed: 800,
            pagination: {
              el: '.dynamic__slider .swiper-pagination',
              clickable: true,
              type: 'bullets',
            },
            navigation: {
              nextEl: '.dynamic__slider .swiper-button-next',
              prevEl: '.dynamic__slider .swiper-button-prev',
            },
          });
        }
      };
      let Pardotform = function () {
        let elements = document.getElementsByClassName('pardotForm');

        if (elements.length) {
          elements.each(function (item) {
            const source = getCookie('utm_source');
            const campaign = getCookie('utm_campaign');
            const medium = getCookie('utm_medium');
            const src = item.getAttribute('src2');
            item.setAttribute('src', src + source + campaign + medium);
          });
        }

        function getCookie(name) {
          name = name + '=';
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return 'utm_' + name + '=' + c.substring(name.length, c.length);
            }
          }

          return '';
        }
      };
      /**
       * @return
       */
      return {
        init: function () {
          Accordion();
          Downloads();
          FloatingBanner();
          Sticky();
          DynamicSlider();
          Pardotform();
        },
      };
    })();

    /**
     * Init GlobalElements
     */
    GlobalElements.init();

    /**
     * Select2
     * Normal
     */
    if ($('.js-select').length) {
      $('.js-select').select2({
        minimumResultsForSearch: Infinity,
        containerCssClass: 'select2-lg',
      });

      $('.js-select-md').select2({
        minimumResultsForSearch: Infinity,
        containerCssClass: 'select2-md',
      });

      $('.js-select-sm').select2({
        minimumResultsForSearch: Infinity,
        containerCssClass: 'select2-sm',
      });
    }

    /**
     * Masonry News and Event
     */
    if ($('.newsevent-masonry').length) {
      var $grid = new Masonry('.newsevent-masonry', {
        percentPosition: true,
        itemSelector: '.item',
        gutter: 0,
        transitionDuration: 0,
        columnWidth: '.grid-sizer',
      });
      $grid.reloadItems();
      $grid.layout();

      setTimeout(function () {
        $grid.reloadItems();
        $grid.layout();
      }, 100);

      $(window).on('resize', function () {
        $grid.reloadItems();
        $grid.layout();
      });
    }

    /**
     * Play Button Video
     */
    if ($('.video-player').length) {
      /**
       * Insert Button
       */
      $('.video-player').each(function () {
        $(this).append($('<a href="#play" class="btn-video-play"></a>'));
      });

      /**
       * Click Button Play
       */
      $(document).on('click', '.btn-video-play', function () {
        const video = $(this).parent().find('video');

        if (video.get(0).paused) {
          video.get(0).play();
          $(this).fadeOut();
        } else {
          video.get(0).pause();
          $(this).fadeIn();
        }
      });
    }

    /********************************************************************
     * Filter Ajax Component
     * News and Events
     * @type {{init: init}}
     */
    let FilterNewsEventAjax = (function () {
      /**
       * const
       * @type {{overlayCSS: {background: string, opacity: number}, message: string}}
       */
      const loader = {
        message: '',
        overlayCSS: { background: '#fff', opacity: 0.6 },
      };

      /**
       * Ajax
       * @param container
       * @param data
       * @constructor
       */
      let Ajax = function (data = '') {
        /**
         *
         * @type {jQuery|HTMLElement}
         */
        const $container_result = $('.filterNewsEvent .resultAjax'), //Container
          $container_items = $container_result.find('.recfilter_section__list'), //Container Items
          $month_panel = $('.filterNewsEventFormMonth'), //Panel Month
          $form = $('.filterNewsEventForm'); //Form

        /**
         * Data
         * @type {string}
         */
        data +=
          $form.serialize() + '&month=' + $('.filterNewsEventFormDate').val();

        $.ajax({
          beforeSend: function () {
            $container_result.block(loader);
          },
          data: data,
          dataType: 'json',
          method: 'POST',
          complete: function () {
            $container_result.unblock();
          },
          success: function (data) {
            if (data.success === false) {
              $('.newsevent-masonry').addClass('recfilter_section__list-empty');
            } else {
              $('.newsevent-masonry').removeClass(
                'recfilter_section__list-empty'
              );
            }

            /**
             * Items
             */

            /**
             * Html
             */
            $container_items.html(data.data.html).ready(function () {
              let grid = new Masonry('.newsevent-masonry');
              grid.reloadItems();
              setTimeout(function () {
                grid = new Masonry('.newsevent-masonry', {
                  percentPosition: true,
                  itemSelector: '.item',
                  isInitLayout: true,
                  gutter: 0,
                  transitionDuration: 0,
                  columnWidth: '.grid-sizer',
                });
              }, 200);
            });

            /**
             * Masonry
             */
            $(window).trigger('resize');

            /**
             * Month Panel
             */
            $month_panel.html(data.data.month);
          },
          url: window.nec.ajax_url,
        });
      };

      /**
       * News and Event
       * @constructor
       */
      let NewsEvent = function () {
        /**
         * Select
         * @change
         */
        $(document).on('change', '.filterNewsEvent select', function () {
          Ajax();
        });

        /**
         * Next or Prev Month
         * @click
         */
        $(document).on('click', '.filterNewsEventMonth', function () {
          const month = $(this).data('month');

          $('.filterNewsEventFormDate').val(month);

          Ajax('month_custom=' + month + '&');
        });
      };

      /**
       * @return
       */
      return {
        init: function () {
          NewsEvent();
        },
      };
    })();

    /**
     * Init Filter Ajax
     */
    FilterNewsEventAjax.init();

    /**
     * Filter Ajax Component
     * Taxonomy
     * @type {{init: init}}
     */
    let FilterTaxonomyAjax = (function () {
      /**
       * const
       * @type {{overlayCSS: {background: string, opacity: number}, message: string}}
       */
      const loader = {
        message: '',
        overlayCSS: { background: '#fff', opacity: 0.6 },
      };

      /**
       * Ajax
       * @param container
       * @param data
       * @constructor
       */
      let Ajax = function (data = '', type = 'post') {
        /**
         *
         * @type {jQuery|HTMLElement}
         */
        const $container = $('.resultTaxonomyAjax'),
          $container_result = $('.resultTaxonomyAjaxPost'),
          $form = $('.filterTaxonomy');

        if ($form.length) {
          /**
           * Data
           * @type {string}
           */
          data +=
            $form.serialize() +
            '&level=' +
            $('[name=select_level]').val() +
            '&place=' +
            $('[name=select_place]').val() +
            '&' +
            '&type=' +
            type;

          $.ajax({
            beforeSend: function () {
              if (type == 'post') {
                $container.block(loader);
              }
            },
            data: data,
            dataType: 'json',
            method: 'POST',
            complete: function () {
              if (type == 'post') {
                $container.unblock();
              } else {
                $('.taxfilter_section__filter-list--input').removeClass(
                  'active'
                );
              }
            },
            success: function (data) {
              /**
               * Search
               */
              if (type == 'search') {
                $('.filterTaxonomySearchResultTax').html(data.data.html);

                return false;
              }

              /**
               * Check Badges
               */
              checkSelectedBadges();

              /**
               * Html
               */
              $container_result.html(data.data.html).ready(function () {});
            },
            url: window.nec.ajax_url,
          });
        }
      };

      /**
       * Select Multiple
       * @constructor
       */
      let Select = function () {
        /**
         *
         */
        $.fn.select2.amd.require(
          [
            'select2/selection/single',
            'select2/selection/placeholder',
            'select2/dropdown',
            'select2/dropdown/attachBody',
            'select2/utils',
          ],
          function (SingleSelection, Placeholder, Dropdown, AttachBody, Utils) {
            var SelectionAdapter = Utils.Decorate(SingleSelection, Placeholder);

            $('.js-select-checkbox').each(function () {
              var $select = $(this),
                placeholder = $(this).data('placeholder');

              $select.select2({
                placeholder: placeholder,
                selectionAdapter: SelectionAdapter,
                closeOnSelect: false,
                dropdownParent: $select.parent(),
                templateResult: function (data) {
                  if (!data.id) {
                    return data.text;
                  }

                  var $res = $('<div></div>');

                  $res.text(data.text);
                  $res.addClass('wrap');

                  $res.attr('data-name', data.text.trim());
                  $res.attr('data-id', data.id.trim());

                  return $res;
                },
                templateSelection: function (data) {
                  if (!data.id) {
                    return data.text;
                  }

                  var selected = ($select.val() || []).length;
                  var total = $('option', $select).length;

                  return placeholder + ' (' + selected + ' of ' + total + ')';
                },
              });
            });
          }
        );

        /**
         * Add Badges
         * @click
         */
        $(document).on('click', '.select2-results__option', function () {
          var id = $(this).find('.wrap').data('id'),
            name = $(this).find('.wrap').data('name');
          var showRow = function (filterObject, rowData, id) {
            var show = true;
            Object.entries(filterObject).forEach(([key]) => {
              show = false;
              var rowArray = rowData.dataset[id]
                .toUpperCase()
                .replace(/\s/g, '')
                .split(',');
              rowArray.forEach((element) => {
                if (filterObject[key].hasOwnProperty(element)) {
                  show = true;
                }
              });
              if (!show) {
                return false;
              }
            });
            return show;
          };
          if ($('.faculty_section').length) {
            var filterObject = {};
            $('.select2-results__option--selected').each(function (i, el) {
              var filter = $(this)
                .closest('.col')
                .find('select')[0]
                .dataset.placeholder.toLowerCase();
              var option = el.innerText.toUpperCase().replace(/\s/g, '');
              filterObject.hasOwnProperty(filter)
                ? ''
                : (filterObject[filter] = {});
              filterObject[filter][option] = 1;
            });
            var row = $('table').find('tr:not(.header)');
            if (!$(this).hasClass('select2-results__option--selected')) {
              row.each(function (i, rowData) {
                var show = showRow(filterObject, rowData, id);
                show
                  ? $(rowData).show().addClass('active')
                  : $(rowData).hide().removeClass('active');
              });
            } else {
              row = $('table').find('tr:not(.header)');
              row.each(function (i, rowData) {
                var show = showRow(filterObject, rowData, id);
                if (show === true) {
                  $(rowData).show().addClass('active');
                } else {
                  $(rowData).hide().removeClass('active');
                }
              });
            }
          } else {
            const url = window.location.origin + window.location.pathname;
            var params = new URLSearchParams(window.location.search);
            var filter = $(this.closest('.col'))
              .find('select')[0]
              .getAttribute('name');
            var param = 'category[]';
            if (filter === 'select_place') {
              param = 'location[]';
            } else if (filter === 'select_level') {
              param = 'level[]';
            }
            if (!$(this).hasClass('select2-results__option--selected')) {
              $('.filterTaxonomyBadges')
                .find('[data-id="' + id + '"]')
                .remove();
              var filteredParams = params
                .getAll(param)
                .filter(function (el) {
                  return el !== name.trim();
                })
                .map(function (el) {
                  return [param, el];
                });
              params.delete(param);
              filteredParams.map(function (el) {
                params.append(param, el);
              });
            } else {
              $('.filterTaxonomyBadges').append(
                '<li data-type="sellect" data-id="' +
                  id +
                  '" data-name="' +
                  name.trim() +
                  '">' +
                  '<a href="#remove-' +
                  id +
                  '">' +
                  name.trim() +
                  '</a>' +
                  '</li>'
              );
              params.append(param, name.trim());
            }
            window.history.replaceState(
              null,
              null,
              url + '?' + params.toString()
            ); // or pushState

            /**
             * Return Ajax
             */
            Ajax();
          }
        });

        Ajax();
      };

      /**
       * Search Input
       * @constructor
       */
      let Search = function () {
        /**
         * @click
         */
        $(document).on('click', '.filterTaxonomySearchResultCat', function (e) {
          e.preventDefault();

          /**
           * const
           * @type {jQuery|HTMLElement}
           */
          const $this = $(this),
            id = $this.data('id'),
            name = $this.text().trim(),
            $inp_cat = $('.filterTaxonomy input[name=category]'),
            def_value = $inp_cat.val();

          /**
           *
           */
          const url = window.location.origin + window.location.pathname;
          var params = new URLSearchParams(window.location.search);
          var param = 'category[]';
          if ($('.filterTaxonomyPanel [data-id=' + id + ']').length) {
            $inp_cat.val(function (index, value) {
              return value.replace(id + ',', '');
            });

            $('.filterTaxonomyPanel [data-id=' + id + ']').remove();
          } else {
            $('.filterTaxonomyBadges').append(
              '<li data-type="category" data-id="' +
                id +
                '" data-name="' +
                name +
                '">' +
                '<a href="#remove-' +
                id +
                '">' +
                name +
                '</a>' +
                '</li>'
            );
            params.append(param, name.trim());
            $inp_cat.val(def_value + id + ',');
          }
          console.log('param');
          window.history.replaceState(
            null,
            null,
            url + '?' + params.toString()
          ); // or pushState
          /**
           * Return Ajax
           */
          Ajax();

          /**
           * Check Badges
           */
          checkSelectedBadges();
        });

        /**
         * @focus
         */
        $(document).on('focus', '.filterTaxonomySearch', function () {
          $('.filterTaxonomySearchResult').addClass('open');
        });

        /**
         * @focusout
         */
        $(document).on('focusout', '.filterTaxonomySearch', function () {});

        /**
         * @keyup
         */
        $(document).on('keyup', '.filterTaxonomySearch', function () {
          const $this = $(this),
            value = $this.val();

          if (value.length) {
            $this.parent().addClass('active');
            $('.filterTaxonomySearchResultDefault').hide();
            $('.filterTaxonomySearchResultTax').show();
          } else {
            $this.parent().removeClass('active');
            $('.filterTaxonomySearchResultDefault').show();
            $('.filterTaxonomySearchResultTax').hide();
          }

          /**
           * Return Ajax
           */
          Ajax('', 'search');
        });

        /**
         * Search Section Group
         * @mouseup
         */
        $(document).mouseup(function (e) {
          var div = $('.filterTaxonomySearchGroup');

          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.filterTaxonomySearchResultDefault').show();
            $('.filterTaxonomySearchResultTax').html('');
            $('.filterTaxonomySearchResult').removeClass('open');
            $('.filterTaxonomySearch').val('');
          }
        });
      };

      /**
       * Panel
       * @constructor
       */
      let Panel = function () {
        /**
         * Remove Badges
         * @click
         */
        $(document).on('click', '.filterTaxonomyBadges a', function (e) {
          var $elem = $(this).parent(),
            id = $elem.data('id'),
            type = $elem.data('type');
          var name = $elem.data('name');
          const url = window.location.origin + window.location.pathname;
          var params = new URLSearchParams(window.location.search);
          var selectBox = $('.js-select-checkbox option[value="' + id + '"]');
          if (type !== 'category') {
            var filter = $(selectBox.closest('.col'))
              .find('select')[0]
              .getAttribute('name');
          }
          var param = 'category[]';
          if (filter === 'select_place') {
            param = 'location[]';
          } else if (filter === 'select_level') {
            param = 'level[]';
          }
          var filteredParams = params
            .getAll(param)
            .filter(function (el) {
              return el !== name.trim();
            })
            .map(function (el) {
              return [param, el];
            });
          params.delete(param);
          filteredParams.map(function (el) {
            params.append(param, el);
          });
          window.history.replaceState(
            null,
            null,
            url + '?' + params.toString()
          ); // or pushState

          $('.js-select-checkbox option[value="' + id + '"]').prop(
            'selected',
            false
          );
          $('.js-select-checkbox').trigger('change');

          $(this).parent().remove();

          /**
           * Replace Category
           */
          if (type === 'category') {
            $('.filterTaxonomy input[name=category]').val(function (
              index,
              value
            ) {
              return value.replace(id + ',', '');
            });
          }

          /**
           * Return Ajax
           */
          Ajax();

          /**
           * preventDefault
           */
          e.preventDefault();
        });

        /**
         * Clear All Filters
         * @click
         */
        $(document).on('click', '.filterTaxonomyClear', function () {
          /**
           *
           */
          $('.js-select-checkbox').val(null).trigger('change');
          $('.filterTaxonomyBadges').html('');

          /**
           * Check Badges
           */
          checkSelectedBadges();
        });

        /**
         * View List
         * @click
         */
        $(document).on('click', '.filterTaxonomyView', function () {
          $(this).toggleClass('grid');

          $('.resultTaxonomyAjaxList').toggleClass('table');
        });
      };

      /**
       * Check Badges
       */
      let checkSelectedBadges = function () {
        const $container = $('.filterTaxonomyPanel'),
          $elem = $container.find('li');

        if ($elem.length) {
          $container.removeClass('hidden');

          $('.resultTaxonomyAjaxCat').hide();
          $('.resultTaxonomyAjaxPost').show();
        } else {
          $container.addClass('hidden');

          $('.resultTaxonomyAjaxCat').show();
          $('.resultTaxonomyAjaxPost').html('').hide();
        }
      };

      /**
       * Mobile
       * @constructor
       */
      let Mobile = function () {
        /**
         * Mobile Filter Open
         * @click
         */
        $(document).on('click', '.filterTaxonomyMobileBtn', function (e) {
          $('body').toggleClass('no-scroll');
          $('.filterTaxonomyMobilePopup').toggleClass('active');

          e.preventDefault();
        });
      };

      /**
       * @return
       */
      return {
        init: function () {
          Select();
          Search();
          Panel();
          Mobile();
        },
      };
    })();
    /**
     * Init Filter Ajax
     */
    FilterTaxonomyAjax.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/program.js